import { configureStore } from '@reduxjs/toolkit';
import platformReducer from './PlatformSlice';

const platformStore = configureStore({
  reducer: {
    platform: platformReducer
  }
});

export default platformStore;